import {
    fromLocationDTO,
    fromLocationsDTO,
    toLocationDTO,
} from './location';

import {
    fromRoleDTO,
    fromRolesDTO,
} from './role'

import {
    fromUserDTO,
    fromUsersDTO,
    toUserDTO,
} from './user'

import {
    fromWorkDayDTO,
    fromWorkDaysDTO,
    toWorkDayDTO,
} from './workDay'

import {
    fromInstituteDTO,
    fromInstitutesDTO,
    toInstituteDTO,
} from './institute';

import {
    fromWorkRecordDTO,
    fromWorkRecordsDTO,
    fromWorkRecordSubmittedStatusDTO,
    fromWorkRecordSubmittedStatusesDTO,
    toWorkRecordSubmittedStatusDTO,
    toAllWorkRecordsDTO,
} from './workRecord'

export default {
    fromLocationDTO,
    fromLocationsDTO,
    toLocationDTO,
    fromRoleDTO,
    fromRolesDTO,
    fromUserDTO,
    fromUsersDTO,
    toUserDTO,
    fromWorkDayDTO,
    fromWorkDaysDTO,
    toWorkDayDTO,
    fromInstituteDTO,
    fromInstitutesDTO,
    toInstituteDTO,
    fromWorkRecordDTO,
    fromWorkRecordsDTO,
    fromWorkRecordSubmittedStatusDTO,
    fromWorkRecordSubmittedStatusesDTO,
    toWorkRecordSubmittedStatusDTO,
    toAllWorkRecordsDTO,
}
